import {
    FlexiEditButton,
    PlatformLoader,
    PlatformPropertyCard,
    PlatformPropertyCardProperty
} from '@flexinet/ui-components';
import {
    Card,
    Group,
    Text,
    ThemeIcon,
    Title,
    Tooltip,
} from '@mantine/core';
import {AiOutlineLock, AiOutlineUser} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';
import {useUserAttributes} from '../../../../hooks/useUserAttributes';
import {emptyState} from './emptyState';

export const IdentityProfile = () => {

    const navigate = useNavigate();

    const {
        givenName,
        familyName,
        email,
    } = useUserAttributes();

    if (!email) {
        return <PlatformLoader message="Loading user...Please, wait!"/>;
    }

    const properties: PlatformPropertyCardProperty[] = [
        {
            label: 'First Name',
            value: givenName || emptyState('Add your first name'),
            span: 6,
        },
        {
            label: 'Last Name',
            value: familyName || emptyState('Add your last name'),
            span: 6,
        },
        {
            label: 'Email',
            value: (
                <Group gap={4} align="center">
                    <Text size="sm">{email}</Text>
                    <Tooltip label="Managed by your identity provider" withArrow>
                        <span style={{display: 'inline-flex'}}>
                            <AiOutlineLock size={12} color="var(--mantine-color-dimmed)"/>
                        </span>
                    </Tooltip>
                </Group>
            ),
            span: 12,
        },
    ];

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Group justify="space-between" mb="md">
                <Group gap="xs">
                    <ThemeIcon variant="outline" size="lg" color="blue">
                        <AiOutlineUser size={20}/>
                    </ThemeIcon>
                    <Title order={5}>Identity</Title>
                </Group>
                <FlexiEditButton
                    onClick={() => navigate('/user-profile/update/#account')}
                    aria-label="Edit name and identity details"
                />
            </Group>
            <PlatformPropertyCard properties={properties}/>
        </Card>
    );
};
